import CommonModule, { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { Client, ClientData } from '@/models/Clients/Client';
import { LoadData } from '@/models/Pagination/LoadData';
import PageList from '@/models/Pagination/PageList';
import { getModule } from 'vuex-module-decorators';

export class ClientService {
    private client: QuestelServicesClient;
    private commonState = getModule(CommonModule, store);

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getClient(clientId: Guid): Promise<ClientData> {
    var response =  await this.client.get<Client>(`/v1/clients/${clientId}`);

    return new ClientData(response);
  }

  //will change the page and pageSize once decided if to paginate the client filter
  public async getClientFilter(): Promise<{Text: string, Value: Guid, Email: string, QuestelEntityId: Guid, DeclarationId?: Guid}[]> {
    return await this.client.get<{Text: string, Value: Guid, Email: string, QuestelEntityId: Guid, DeclarationId?: Guid}[]>(`/v1/clients/options`);
    }

    public async updateFile(clientId: Guid, data: FormData, deletefile: boolean) {
        return await this.client.upload<Guid>(`/api/v1/Clients/${clientId}/upload?deleteFile=${deletefile}`, data, "");
    }

  public async getClients(dataQuery: LoadData): Promise<PageList<ClientData>> {
    const queryString = Object.keys(dataQuery).filter(prop => dataQuery[prop])
                      .map(key => {
                        return `${key}=${encodeURIComponent(dataQuery[key])}`
                      })
                      .join('&');
    const response = await this.client.get<PageList<Client>>(`/v1/clients?${queryString}`)

    return {
      Data: response.Data.map(c => new ClientData(c)),
      PageNumber: response.PageNumber,
      PageSize: response.PageSize,
      TotalItemCount: response.TotalItemCount
    }
    }

    public async downloadGeneralDeclaration(clientId: Guid): Promise<any> {
        var request = new Request(`/api/v1/clients/DownloadGeneralDeclaration/${clientId}`, {
            method: HttpMethodEnum.Get,
            headers: {
                "Authorization": `Bearer ${this.commonState.authToken}`,
            },
        });

        return fetch(request);
    }

  public async addClient(client: Client): Promise<RequestResult<Client>> {
    return await this.client.postJson<Client>(`/v1/clients`, client);
  }

  public async updateClient(client: Client): Promise<RequestResult<Client>> {
    return await this.client.putJson<Client>(`/v1/clients`, client);
  }
}